function floatToString(t, r) {
  var a = t.toFixed(r).toString()
  return a.match(/^\.\d+/) ? '0' + a : a
}
function attributeToString(t) {
  return (
    'string' != typeof t && 'undefined' == (t += '') && (t = ''), jQuery.trim(t)
  )
}
void 0 === window.Shopify && (window.Shopify = {}),
  (Shopify.money_format = '${{amount}}'),
  (Shopify.onError = function (t, r) {
    var e = eval('(' + t.responseText + ')')
    e.message
      ? alert(e.message + '(' + e.status + '): ' + e.description)
      : alert('Error : ' + Shopify.fullMessagesFromErrors(e).join('; ') + '.')
  }),
  (Shopify.fullMessagesFromErrors = function (t) {
    var r = []
    return (
      jQuery.each(t, function (t, a) {
        jQuery.each(a, function (a, n) {
          r.push(t + ' ' + n)
        })
      }),
      r
    )
  }),
  (Shopify.onCartUpdate = function (t) {
    alert('There are now ' + t.item_count + ' items in the cart.')
  }),
  (Shopify.onCartShippingRatesUpdate = function (t, r) {
    var a = ''
    r.zip && (a += r.zip + ', '),
      r.province && (a += r.province + ', '),
      (a += r.country),
      alert(
        'There are ' +
          t.length +
          ' shipping rates available for ' +
          a +
          ', starting at ' +
          Shopify.formatMoney(t[0].price) +
          '.'
      )
  }),
  (Shopify.onItemAdded = function (t) {
    console.log(t.title + ' was added to your shopping cart.')
    window.open(document.location.origin+"/cart","_self");
  }),
  (Shopify.onProduct = function (t) {
    console.log('Received everything we ever wanted to know about ' + t.title)
  }),
  (Shopify.formatMoney = function (t, r) {
    function a(t, r) {
      return void 0 === t ? r : t
    }
    function n(t, r, n, e) {
      if (
        ((r = a(r, 2)), (n = a(n, ',')), (e = a(e, '.')), isNaN(t) || null == t)
      )
        return 0
      var o = (t = (t / 100).toFixed(r)).split('.')
      return (
        o[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + n) +
        (o[1] ? e + o[1] : '')
      )
    }
    'string' == typeof t && (t = t.replace('.', ''))
    var e = '',
      o = /\{\{\s*(\w+)\s*\}\}/,
      i = r || this.money_format
    switch (i.match(o)[1]) {
      case 'amount':
        e = n(t, 2)
        break
      case 'amount_no_decimals':
        e = n(t, 0)
        break
      case 'amount_with_comma_separator':
        e = n(t, 2, '.', ',')
        break
      case 'amount_with_space_separator':
        e = n(t, 2, ' ', ',')
        break
      case 'amount_with_period_and_space_separator':
        e = n(t, 2, ' ', '.')
        break
      case 'amount_no_decimals_with_comma_separator':
        e = n(t, 0, '.', ',')
        break
      case 'amount_no_decimals_with_space_separator':
        e = n(t, 0, '.', '')
        break
      case 'amount_with_space_separator':
        e = n(t, 2, ',', '')
        break
      case 'amount_with_apostrophe_separator':
        e = n(t, 2, "'", '.')
    }
    return i.replace(o, e)
  }),
  (Shopify.resizeImage = function (t, r) {
    try {
      if ('original' == r) return t
      var a = t.match(/(.*\/[\w\-\_\.]+)\.(\w{2,4})/)
      return a[1] + '_' + r + '.' + a[2]
    } catch (n) {
      return t
    }
  }),
  (Shopify.addItem = function (t, r, a) {
    var n = {
      type: 'POST',
      url: '/cart/add.js',
      data: 'quantity=' + (r = r || 1) + '&id=' + t,
      dataType: 'json',
      success: function (t) {
        'function' == typeof a ? a(t) : Shopify.onItemAdded(t)
      },
      error: function (t, r) {
        Shopify.onError(t, r), debloquerPage(), console.log('toto')
      },
    }
    jQuery.ajax(n)
  }),
  (Shopify.addItemFromForm = function (t, r) {
    var a = {
      type: 'POST',
      url: '/cart/add.js',
      data: jQuery('#' + t).serialize(),
      dataType: 'json',
      success: function (t) {
        'function' == typeof r ? r(t) : Shopify.onItemAdded(t)
      },
      error: function (t, r) {
        Shopify.onError(t, r)
      },
    }
    jQuery.ajax(a)
  }),
  (Shopify.getCart = function (t) {
    jQuery.getJSON('/cart.js', function (r) {
      'function' == typeof t ? t(r) : Shopify.onCartUpdate(r)
    })
  }),
  (Shopify.pollForCartShippingRatesForDestination = function (t, r, a) {
    a = a || Shopify.onError
    var n = function () {
      jQuery.ajax('/cart/async_shipping_rates', {
        dataType: 'json',
        success: function (a, e, o) {
          200 === o.status
            ? 'function' == typeof r
              ? r(a.shipping_rates, t)
              : Shopify.onCartShippingRatesUpdate(a.shipping_rates, t)
            : setTimeout(n, 500)
        },
        error: a,
      })
    }
    return n
  }),
  (Shopify.getCartShippingRatesForDestination = function (t, r, a) {
    a = a || Shopify.onError
    var n = {
      type: 'POST',
      url: '/cart/prepare_shipping_rates',
      data: Shopify.param({ shipping_address: t }),
      success: Shopify.pollForCartShippingRatesForDestination(t, r, a),
      error: a,
    }
    jQuery.ajax(n)
  }),
  (Shopify.getProduct = function (t, r) {
    jQuery.getJSON('/products/' + t + '.js', function (t) {
      'function' == typeof r ? r(t) : Shopify.onProduct(t)
    })
  }),
  (Shopify.changeItem = function (t, r, a) {
    var n = {
      type: 'POST',
      url: '/cart/change.js',
      data: 'quantity=' + r + '&id=' + t,
      dataType: 'json',
      success: function (t) {
        'function' == typeof a ? a(t) : Shopify.onCartUpdate(t)
      },
      error: function (t, r) {
        Shopify.onError(t, r)
      },
    }
    jQuery.ajax(n)
  }),
  (Shopify.removeItem = function (t, r) {
    var a = {
      type: 'POST',
      url: '/cart/change.js',
      data: 'quantity=0&id=' + t,
      dataType: 'json',
      success: function (t) {
        'function' == typeof r ? r(t) : Shopify.onCartUpdate(t)
      },
      error: function (t, r) {
        Shopify.onError(t, r)
      },
    }
    jQuery.ajax(a)
  }),
  (Shopify.clear = function (t) {
    var r = {
      type: 'POST',
      url: '/cart/clear.js',
      data: '',
      dataType: 'json',
      success: function (r) {
        'function' == typeof t ? t(r) : Shopify.onCartUpdate(r)
      },
      error: function (t, r) {
        Shopify.onError(t, r)
      },
    }
    jQuery.ajax(r)
  }),
  (Shopify.updateCartFromForm = function (t, r) {
    var a = {
      type: 'POST',
      url: '/cart/update.js',
      data: jQuery('#' + t).serialize(),
      dataType: 'json',
      success: function (t) {
        'function' == typeof r ? r(t) : Shopify.onCartUpdate(t)
      },
      error: function (t, r) {
        Shopify.onError(t, r)
      },
    }
    jQuery.ajax(a)
  }),
  (Shopify.updateCartAttributes = function (t, r) {
    var a = ''
    jQuery.isArray(t)
      ? jQuery.each(t, function (t, r) {
          var n = attributeToString(r.key)
          '' !== n &&
            (a += 'attributes[' + n + ']=' + attributeToString(r.value) + '&')
        })
      : 'object' == typeof t &&
        null !== t &&
        jQuery.each(t, function (t, r) {
          a +=
            'attributes[' +
            attributeToString(t) +
            ']=' +
            attributeToString(r) +
            '&'
        })
    var n = {
      type: 'POST',
      url: '/cart/update.js',
      data: a,
      dataType: 'json',
      success: function (t) {
        'function' == typeof r ? r(t) : Shopify.onCartUpdate(t)
      },
      error: function (t, r) {
        Shopify.onError(t, r)
      },
    }
    jQuery.ajax(n)
  }),
  (Shopify.updateCartNote = function (t, r) {
    var a = {
      type: 'POST',
      url: '/cart/update.js',
      data: 'note=' + attributeToString(t),
      dataType: 'json',
      success: function (t) {
        'function' == typeof r ? r(t) : Shopify.onCartUpdate(t)
      },
      error: function (t, r) {
        Shopify.onError(t, r)
      },
    }
    jQuery.ajax(a)
  }),
  '1.4' <= jQuery.fn.jquery
    ? (Shopify.param = jQuery.param)
    : ((Shopify.param = function (t) {
        var r = [],
          a = function (t, a) {
            ;(a = jQuery.isFunction(a) ? a() : a),
              (r[r.length] =
                encodeURIComponent(t) + '=' + encodeURIComponent(a))
          }
        if (jQuery.isArray(t) || t.jquery)
          jQuery.each(t, function () {
            a(this.name, this.value)
          })
        else for (var n in t) Shopify.buildParams(n, t[n], a)
        return r.join('&').replace(/%20/g, '+')
      }),
      (Shopify.buildParams = function (t, r, a) {
        jQuery.isArray(r) && r.length
          ? jQuery.each(r, function (r, n) {
              rbracket.test(t)
                ? a(t, n)
                : Shopify.buildParams(
                    t +
                      '[' +
                      ('object' == typeof n || jQuery.isArray(n) ? r : '') +
                      ']',
                    n,
                    a
                  )
            })
          : null != r && 'object' == typeof r
          ? Shopify.isEmptyObject(r)
            ? a(t, '')
            : jQuery.each(r, function (r, n) {
                Shopify.buildParams(t + '[' + r + ']', n, a)
              })
          : a(t, r)
      }),
      (Shopify.isEmptyObject = function (t) {
        for (var r in t) return !1
        return !0
      }))
